import * as types from './actionTypes';
import getAPIPath from '../../js/modules/api-location';
import handleErrors from './handleErrors';

export function loadTrainingGroundContentFeedSuccess(content) {
  return { type: types.LOAD_TRAINING_GROUND_CONTENT_FEED_SUCCESS, content };
}

export function getTrainingGroundPopularSearchesSuccess(data) {
  return { type: types.GET_TRAINING_GROUND_POPULAR_SEARCHES, data };
}

export function loadTrainingGroundContentFeed() {
  return function(dispatch) {
    return fetch(`${getAPIPath}queryapi/content/tg-content-feed`, {
      method: `GET`,
      credentials: `include`,
      headers: {
        Accept: `application/json`,
      },
    })
    .then(handleErrors)
    .then((response) => {
      response.json().then((res) => {
        dispatch(loadTrainingGroundContentFeedSuccess(res.data));
      });
    })
    .catch((error) => {
      throw (error);
    });
  };
}

export function getTrainingGroundPopularSearches() {
  return function(dispatch) {
    return fetch(`${getAPIPath}queryapi/get-all-preset-searches`, {
      method: `GET`,
      credentials: `include`,
      headers: {
        Accept: `application/json`,
      },
    })
    .then(handleErrors)
    .then((response) => {
      response.json().then((res) => {
        dispatch(getTrainingGroundPopularSearchesSuccess(res.data));
      });
    })
    .catch((error) => {
      throw (error);
    });
  };
}


// WEBPACK FOOTER //
// ./library/app/actions/trainingGroundActions.js